import React from "react";

import { Check20, Remove20 } from "@/components/ui/SvgIcon";

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  isChecked?: boolean;
  isIndeterminate?: boolean;
  onChange?: (checked: boolean) => void;
};

export const Checkbox = ({
  isChecked,
  isIndeterminate,
  onChange,
  ...props
}: Props) => {
  const checkboxRef = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = isIndeterminate ?? false;
    }
  }, [isIndeterminate]);

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e.target.checked);
    }
  };

  return (
    <label className="relative inline-flex size-4 cursor-pointer">
      <input
        type="checkbox"
        className="peer hidden"
        checked={isChecked ?? false}
        onChange={handleOnChange}
        data-testid="checkbox"
        {...props}
      />
      <span className="absolute left-0 top-0 size-4 rounded-sm border border-chorus-gray-300 bg-white peer-checked:hidden peer-disabled:bg-chorus-gray-300"></span>
      <div className="absolute left-0 top-0 hidden size-4 rounded-sm bg-chorus-teal-200 text-chorus-teal-950 peer-checked:block peer-disabled:bg-chorus-gray-200 peer-disabled:text-chorus-gray-700">
        {isChecked && !isIndeterminate && (
          <Check20
            className="absolute left-0 top-0 -m-0.5 fill-current"
            data-testid="checkbox-checked"
          />
        )}
        {isChecked && isIndeterminate && (
          <Remove20
            className="absolute left-0 top-0 -m-0.5 fill-current"
            data-testid="checkbox-indeterminate"
          />
        )}
      </div>
    </label>
  );
};
